//import { useAuth } from "react-oidc-context";
import { uiEncryption } from "./common";
import DOMPurify from "dompurify";
import secureLocalStorage from "react-secure-storage";

export function login(loginToken: string) {
  if (loginToken) {
    secureLocalStorage.setItem("token", loginToken);
  }
}

export function setWrapperLoginToken(
  loginToken: string,
  authenticLoginToken: string
) {
  if (loginToken && process.env.MO_VITE_ORIGIN) {
    secureLocalStorage.setItem("wrapper_token", loginToken);

    // encrypt
    const encrypt = uiEncryption(
      JSON.stringify({
        authenticToken: authenticLoginToken,
        wrapperToken: loginToken,
      })
    );

    setTimeout(function () {
      window.location.replace(
        process.env.MO_VITE_ORIGIN + "setssotoken?etokens=" + encrypt
      );
    }, 2000);
  }
}

export function isLogin() {
  const token = DOMPurify.sanitize(
    secureLocalStorage.getItem("token") as string
  );
  return token;
}

export function getToken() {
  if (secureLocalStorage.getItem("token")) {
    return DOMPurify.sanitize(secureLocalStorage.getItem("token") as string);
  }
}

export function getWrapperToken() {
  if (
    secureLocalStorage.getItem("token") &&
    secureLocalStorage.getItem("wrapper_token")
  ) {
    return DOMPurify.sanitize(
      secureLocalStorage.getItem("wrapper_token") as string
    );
  }
}

function openPopup(fromMo?: boolean) {
  const newWindow = window.open(
    "https://authentik.grnconnect.com/api/v3/flows/executor/default-invalidation-flow/",
    // "popupWindow",
    // "width=200,height=100"
    "_blank"
  );

  if (newWindow) {
    newWindow.focus();
    setTimeout(
      () => {
        newWindow.close();
      },
      fromMo ? 100 : 100
    );
  }
}

// export const useAuthentikLogout = () => {
//   const auth = useAuth();
//   auth.removeUser();
//   auth.signoutRedirect();
//   localStorage.removeItem("token");
//   localStorage.removeItem("wrapper_token");
// };

export function logout(fromMo?: boolean) {
  const token = DOMPurify.sanitize(localStorage.getItem("token") as string);
  if (token) {
    openPopup(fromMo);
    setTimeout(() => {
      localStorage.removeItem("persist:root");
      localStorage.removeItem("token");
      localStorage.clear();
      sessionStorage.clear();

      // const basename = process.env.BASE_NAME;
      // if (
      //   window.location.pathname !== `${basename}home` &&
      //   window.location.pathname !== "/authenticateLoginResponse"
      // ) {
      //   return (window.location.href = "home");
      // }

      // window.location.href = "home";
      window.location.href = process.env.MO_VITE_ORIGIN + "logoutr-frombe";
    }, 5);
  }
}

// export const isGlobalApolloError = (error: any) => {
//   const isAuthError = error?.graphQLErrors?.some(
//     (err: any) => err?.extensions?.code === "AUTH_NOT_AUTHORIZED"
//   );

//   const isServerError =
//     error?.networkError &&
//     "statusCode" in error.networkError &&
//     error.networkError.statusCode >= 500;

//   return isAuthError || isServerError;
// };

export const isGlobalApolloError = (error: any) => {
  const graphQLErrors =
    error?.graphQLErrors?.length
      ? error.graphQLErrors
      : error?.networkError?.result?.errors || [];

  const isAuthError = graphQLErrors.some(
    (err: any) =>
      err?.extensions?.code === "AUTH_NOT_AUTHORIZED" ||
      err?.message ===
        "The current user is not authorized to access this resource."
  );

  return isAuthError;
};
